interface PreviewProps {
  src: string;
  alt?: string;
}

export const Preview = ({ src, alt = 'Preview image' }: PreviewProps) => {
  return (
    <section
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        gap: '33px',
        width: '100%',
      }}
    >
      <img
        src={src}
        alt={alt}
        style={{
          width: '100%',
          height: 'auto',
          borderRadius: '6px',
          display: 'block',
        }}
      />
    </section>
  );
};

